<template>
  <main class="container-fluid mb-110">
    <div class="newTable select">
      <div class="col-12 search mb-3">
        <div class="titleStyle mt-5 mb-3">確認家戶成員</div>
        <div class="subTitleStyle mb-3">請確認成員身分與基本資料</div>
      </div>
      <div>
        <mv-add-family-modify
          :familyrlType="'B'"
          @save-items-data="checkDataM"
          ref="mvAddFamilyModify"
          :selectedFamily="[]"
          :isMate="isMate"
        />
        <mv-add-family :originalFamily="selectedHolder" @sendFamilyResult="sendFamilyResult"/>
      </div>
    </div>
    <fixed-bottom>
      <template slot="@function">
        <div class="actions text-right">
          <a
            @click="$router.go(-1)"
            class="btn btn-default btn-custStyle mr-3"
            >上一步</a
          >
          <a @click="addFamily" class="btn btn-primary btn-custStyle">加入</a>
        </div>
      </template>
    </fixed-bottom>
    <mv-info :open="mvInfoOpen" @close="closeModal()">
      <div class="text font-20" slot="content">
        <div class="mt-10">
          原家戶戶長 <span style="color:#027a39;font-weight:600">{{ truncate(familyLeaderName,12) }}</span> 已重新歸戶，
        </div>
        <div class="text-red">需從原家戶剩下的家戶成員中，指定一位新戶長。</div>
      </div>
    </mv-info>
    <!-- 打開遮罩 -->
    <mv-mask :open="mvMaskOpen" :content="maskContent" />
  </main>
</template>

<script>
import moment from "moment";
import Avatar from "@/desktop/components/Avatar";
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import { mapGetters } from "vuex";
import {
  getFamilyMemberBycondition,
  getAllHouseholderBySales,
  addMembersToFamily,
  getFamilyMemberByCsidNo,
} from "@/service";
import mvAddFamilyModify from "@/desktop/views/mv/components/mvAddFamilyModify";
import mvAddFamily from "@/desktop/views/mv/components/mvAddFamily";
import mvInfo from "@/desktop/views/mv/components/mvInfo";
import { log } from "util";
import mvMask from "@/desktop/views/mv/components/mvMask";
import FixedBottom from "@/desktop/views/mv/components/modal/fixedBotton";

export default {
  name: "checkAddFamily",
  mixins: [commonMixin],
  data() {
    return {
      //上頁選擇戶長
      selectedHolder: this.$route.params.selectedHolder,
      //彈窗
      mvInfoOpen: false,
      //戶長名字
      familyLeaderName: "",
      //遮罩
      mvMaskOpen: false,
      //遮罩字樣
      maskContent: "",
      //原成員是否有配偶
      isMate: false
    };
  },
  components: {
    Avatar,
    mvAddFamilyModify,
    mvAddFamily,
    mvInfo,
    mvMask,
    FixedBottom,
  },
  computed: {
    ...mapGetters(["BaseUrl", "FamilyResultFilter", "UserInfo"]),
  },
  methods: {
    moment,
    ...mapActions([
      "updateUserItems",
      "updateAllHolderSearchData",
      "setPageLock",
    ]),
    sendFamilyResult(val){
      this.isMate = val
    },
    checkDataM(val) {     
      if (val !== "false" && val !== "true") {
        this.familyLeaderName = val;
        this.registerHanlink();
        this.panelOpen("mvInfoOpen");
      } else if (val == "true") {
        this.maskContent = "資料更新中，請稍候...";
        this.panelOpen("mvMaskOpen");
        addMembersToFamily(
          this.UserInfo.id,
          this.selectedHolder,
          this.FamilyResultFilter
        ).then((result) => {
          if (result.header && result.header.status == "200") {
            getFamilyMemberByCsidNo(this.UserInfo.id, this.selectedHolder).then(
              (csidresult) => {
                if (csidresult.header && csidresult.data) {
                  var familyLeader = csidresult.data.filter((obj) => {
                    return obj.familyrl === 0;
                  });
                  this.$toast.info({ title: "歸戶成功" });
                  this.panelClose("mvMaskOpen");
                  this.updateUserItems(familyLeader[0]);
                  localStorage.userItems = JSON.stringify(familyLeader[0]);
                   if (this.$store.state.isPageFromMv === false) {
                    this.$router.push({ name: 'customer-detail-2' });
                  } else {
                    this.$router.push({ name: 'familyRelation' });
                  }
                }
              }
            );
          } else {
            this.$toast.info({ title: "歸戶失敗" });
            this.panelClose("mvMaskOpen");
          }
        });
      }
    },
    addFamily() {
      this.$refs.mvAddFamilyModify.saveItems();
    },
    closeModal() {
      this.panelClose("mvInfoOpen");
      this.$router.push({
        name: "changeFamilyLeader",
        params: { selectedHolder: this.selectedHolder },
      });
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.mb-110 {
  margin-bottom: 110px;
}

.titleStyle {
  font-family: PingFangTC;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #027a39;
}
.subTitleStyle {
  font-family: PingFangTC;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #323a45;
}
.btn-custStyle {
  padding-top:9px !important;
  width:120px;
  height: 40px;
}
</style>